export default "__VITE_ASSET__2d2caa8d__"